import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Entities, fetchById, getUpdatedEntity, patch, save } from 'src/common/index';
import ErrorMessage from 'src/components/misc/error-message';
import ReviewCategoryEditForm from 'src/components/admin/reviewcategories/review-category-edit-form';

class ReviewCategoryEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id } = this.props;

        if (!isCreate) this.props.fetchById(id, Entities.REVIEW_CATEGORY);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { reviewCategory } = nextProps;

        if (!this.state.startedFetching && reviewCategory.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { reviewCategory, isCreate, t } = this.props;

        const finishFetching = this.state.startedFetching && !reviewCategory.isFetching;

        if (finishFetching) {
            // check for errors
            if (reviewCategory.error) return <ErrorMessage object={reviewCategory} />;
            // if everything is ok populate form
            else {
                let initialValues;

                // populate form for editing an existing review category
                if (!isCreate && reviewCategory.content)
                    initialValues = {
                        id: reviewCategory.content.id,
                        name: reviewCategory.content.name,
                        factor: reviewCategory.content.factor || 0,
                        position: reviewCategory.content.position || 0,
                        active: reviewCategory.content.position || false,
                    };
                else
                    initialValues = {
                        active: false,
                    };

                return (
                    <ReviewCategoryEditForm
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        reviewCategory={reviewCategory.content}
                        t={t}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { isCreate, handleClose } = this.props;

        if (!isCreate) this.props.patch(data, Entities.REVIEW_CATEGORY);
        else this.props.save(data, Entities.REVIEW_CATEGORY);

        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        reviewCategory: getUpdatedEntity(state, Entities.REVIEW_CATEGORY),
    };
};

export default connect(mapStateToProps, { fetchById, patch, save }, null, { withRef: true })(ReviewCategoryEditModal);
